import { render, staticRenderFns } from "./userBar.vue?vue&type=template&id=0388c737&scoped=true"
import script from "./userBar.vue?vue&type=script&lang=js"
export * from "./userBar.vue?vue&type=script&lang=js"
import style0 from "./userBar.vue?vue&type=style&index=0&id=0388c737&prod&lang=scss&scoped=true"
import style1 from "@/styles/pc.css?vue&type=style&index=1&id=0388c737&prod&scoped=true&lang=css&external"
import style2 from "./userBar.vue?vue&type=style&index=2&id=0388c737&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0388c737",
  null
  
)

export default component.exports